import { render, staticRenderFns } from "./PermGroupEditDialog.vue?vue&type=template&id=6b1eaca4&"
import script from "./PermGroupEditDialog.vue?vue&type=script&lang=ts&"
export * from "./PermGroupEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports